import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { TrendingUp, TrendingDown } from "lucide-react";

const PerformanceChart = ({ chartData = [] }) => {
  // Función para formatear el valor de las ganancias
  const formatCurrency = (value) => {
    return `$${value.toFixed(2)}`;
  };

  // Datos predeterminados en caso de que no lleguen datos
  const defaultData =
    chartData.length > 0
      ? chartData
      : [
          { name: "Ene", value: 0 },
          { name: "Feb", value: 0 },
          { name: "Mar", value: 0 },
          { name: "Abr", value: 0 },
          { name: "May", value: 0 },
          { name: "Jun", value: 0 },
        ];

  // Calcular el valor máximo para mostrar en el gráfico
  const dataMax = Math.max(...defaultData.map((item) => item.value)) || 100;

  // Calcular la tendencia (incremento porcentual entre el primer y último valor)
  const firstValue = defaultData[0]?.value || 0;
  const lastValue = defaultData[defaultData.length - 1]?.value || 0;
  const percentageChange =
    firstValue === 0 ? 0 : ((lastValue - firstValue) / firstValue) * 100;

  // Determinar si la tendencia es positiva o negativa
  const isPositiveTrend = percentageChange >= 0;

  return (
    <div className="bg-gray-800 rounded-lg p-6 shadow-lg h-full">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-semibold text-white">
          Rendimiento Mensual
        </h3>
        <div
          className={`flex items-center text-sm ${
            isPositiveTrend ? "text-green-400" : "text-red-400"
          }`}
        >
          {isPositiveTrend ? (
            <TrendingUp size={18} className="mr-1" />
          ) : (
            <TrendingDown size={18} className="mr-1" />
          )}
          <span>
            {isPositiveTrend ? "+" : ""}
            {percentageChange.toFixed(1)}%
          </span>
        </div>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={defaultData}
            margin={{
              top: 5,
              right: 5,
              left: 5,
              bottom: 5,
            }}
          >
            <defs>
              <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis
              dataKey="name"
              tick={{ fill: "#9ca3af" }}
              axisLine={{ stroke: "#4b5563" }}
            />
            <YAxis
              tickFormatter={formatCurrency}
              tick={{ fill: "#9ca3af" }}
              axisLine={{ stroke: "#4b5563" }}
              domain={[0, dataMax * 1.2]}
            />
            <Tooltip
              formatter={(value) => [formatCurrency(value), "Ganancias"]}
              contentStyle={{
                backgroundColor: "#1f2937",
                borderColor: "#374151",
                color: "#e5e7eb",
              }}
              itemStyle={{ color: "#e5e7eb" }}
              labelStyle={{ color: "#e5e7eb" }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#3b82f6"
              fillOpacity={1}
              fill="url(#colorValue)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 text-sm text-gray-400">
        <p>Ganancias acumuladas en los últimos 6 meses</p>
      </div>
    </div>
  );
};

export default PerformanceChart;
